import React, { useState } from 'react';
import { LangText } from '../textLang';
import styled from './EmarsysConf.module.scss';
//import { EFEmail } from '@/components/UI/svg/Footer';
import { subscribeMultiEmarsysEmail } from './service';
import { message } from '@/components/UI/Message';
import EFEmail from '@/components/UI/svg/Footer/Icon/EFEmail';
import { useGlobal } from '@/utils/useGlobal';
import { subscribeCookie } from '@/utils/cookies/subscribeCookie';

interface IEmarsysProps {
    defaultValue?: string;
    submitText: string;
    placeholder: string;
    source?: string;
    disabled?: boolean;
    successCallback?: any;
    errorCallback?: () => void;
    align?: string; // 配置化外部需要控制样式
    emarsysFields?: any;
    isChecked?: boolean;
    setShowErrorTips: any;
    setTipsMessage: any;
    setTipsType: any;
}
const reg = /^[A-Za-z\d]+([.%~`$^*&(){}<>?"+=!_\\-]*[A-Za-z\d-])*@[a-zA-Z\d-]{1,30}\.[a-zA-Z\d.%#~`$^*&(){}<>?"+=!_\\-]{1,30}$/;
const EmarsysConf: React.FC<IEmarsysProps> = ({
    defaultValue = '',
    submitText,
    placeholder,
    source = 'ECO_CREDITS_DAY',
    disabled = false,
    successCallback,
    errorCallback,
    align,
    emarsysFields = {},
    isChecked,
    setShowErrorTips,
    setTipsMessage,
    setTipsType,
}) => {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('shared');
    const [inputValue, setInputValue] = useState(defaultValue || '');
    const [loading, setLoading] = useState(false);
    const isDisabled = !reg.test(inputValue) || disabled;
    const contactListIdA = emarsysFields.contactListId || []; //可能没有选的呀
    const params = {
        ...emarsysFields,
        email: inputValue,
        contactListId: contactListIdA[0] || 0,
        source,
    };

    const handleSubmit = () => {
        if (!inputValue) {
            setTipsMessage(LangText[locale].email_error_tip1);
            setTipsType('error');
            return;
        }
        if (!isChecked) {
            setShowErrorTips && setShowErrorTips(true);
            return;
        }
        if (!reg.test(inputValue)) {
            setTipsMessage(LangText[locale].email_error_tip2);
            return;
        }

        setShowErrorTips && setShowErrorTips(false);
        setLoading(true);
        subscribeMultiEmarsysEmail(
            locale,
            params,
            subscribeCookie({
                sector_name: submitText,
                entry_position: 0,
            }),
        )
            .then((res) => {
                setLoading(false);
                if (res.code !== '0' && res.code !== '2058') {
                    errorCallback && errorCallback();
                    return message.error(res.message);
                }
                successCallback && successCallback(inputValue);
                setInputValue('');
                setTipsMessage(LangText[locale].success_tips);
                setTipsType('success');
                setTimeout(() => {
                    setTipsMessage('');
                    setTipsType('');
                }, 4000);
            })
            .catch((err) => {
                setLoading(false);
                console.log(err);
                errorCallback && errorCallback();
            });
    };

    const handleEmailChange = (e: any) => {
        if (!e.target.value) {
            setTipsMessage('');
            return;
        }
        if (reg.test(e.target.value)) {
            setTipsMessage('');
        } else {
            setTipsMessage(LangText[locale].email_error_tip2);
        }
    };

    return (
        <div className={`${styled.EmarsysConf} ${styled[align as string]}`}>
            <div className={`emarsys_main`}>
                <div className="emarsys_input">
                    <span className="emarsys_icon">
                        <EFEmail />
                    </span>
                    <input
                        type="email"
                        value={inputValue}
                        onChange={handleEmailChange}
                        pattern=".*"
                        title=""
                        onInput={(e) => setInputValue(e.target.value.trim())}
                        placeholder={placeholder ?? LangText[locale].emailPlace}
                    />
                </div>
                <div className="emarsys_submit">
                    <button type="submit" className="emarsys_submit_button" onClick={handleSubmit}>
                        {submitText}
                    </button>
                </div>
            </div>
        </div>
    );
};
export default EmarsysConf;
